export default function extractCisId(jid) {
  const id = jid.split('@')[0]
  const idParts = id.split('.')
  return `${idParts[0]}.${idParts[1]}.${idParts[2]?.toUpperCase()}`
}
export const upperCaseCisId = (cisId) => {
  const idParts = cisId.split('.')
  return `${idParts[0]}.${idParts[1]}.${idParts[2]?.toUpperCase()}`
}
